import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {

    trioFunnelbg: {
        texture: '/img/partials/funnel/trio-funnel-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    funnelUnder: {
        texture: '/img/partials/funnel/funnel-under.png',
        scale: {
            x: '85%',
        },
        position: {
            x: '8%',
            y: '46%'
        }
    },

    funnelOver: {
        texture: '/img/partials/funnel/funnel-over.png',
        scale: {
            x: '93%',
        },
        position: {
            x: '8%',
            y: '46%'
        }
    },

    funnelLid: {
        texture: '/img/partials/funnel/funnel-lid.png',
        scale: {
            x: '93%',
        },
        position: {
            x: '8%',
            y: '45.7%'
        }
    },

    //---------------------------------------------------------------------------------------

    baldGuyLeft1: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/bald-guy/1/left-bald-guy-0.png',
            '/img/partials/funnel/trio/left/bald-guy/1/left-bald-guy-1.png',
            '/img/partials/funnel/trio/left/bald-guy/1/left-bald-guy-2.png',
            '/img/partials/funnel/trio/left/bald-guy/1/left-bald-guy-3.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,bald-guy/1`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        },
    },

    baldGuyLeft2: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/bald-guy/2/left-bald-guy-0.png',
            '/img/partials/funnel/trio/left/bald-guy/2/left-bald-guy-1.png',
            '/img/partials/funnel/trio/left/bald-guy/2/left-bald-guy-2.png',
            '/img/partials/funnel/trio/left/bald-guy/2/left-bald-guy-3.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,bald-guy/2`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        },
    },

    baldGuyLeft3: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/bald-guy/3/left-bald-guy-0.png',
            '/img/partials/funnel/trio/left/bald-guy/3/left-bald-guy-1.png',
            '/img/partials/funnel/trio/left/bald-guy/3/left-bald-guy-2.png',
            '/img/partials/funnel/trio/left/bald-guy/3/left-bald-guy-3.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,bald-guy/3`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        }
    },

    baldGuyMiddle: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/middle/bald-guy/bald-guy-middle.png',
        //     '/img/partials/funnel/trio/middle/bald-guy/bald-guy-left.png',
        //     '/img/partials/funnel/trio/middle/bald-guy/bald-guy-right.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/middle-${prefix}.json,bald-guy/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '10%',
            y: '22%'
        }
    },

    baldGuyRight: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-0.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-1.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-2.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-3.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-4.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-5.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-6.png',
        //     '/img/partials/funnel/trio/right/bald-guy/right-bald-guy-7.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/right-${prefix}.json,bald-guy/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '25%',
            y: '18%'
        }
    },

    baldGuyRotation: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/rotation/bald-guy/rotation-bald-guy-0.png',
        //     '/img/partials/funnel/trio/rotation/bald-guy/rotation-bald-guy-1.png',
        //     '/img/partials/funnel/trio/rotation/bald-guy/rotation-bald-guy-2.png',
        //     '/img/partials/funnel/trio/rotation/bald-guy/rotation-bald-guy-3.png',
        //     '/img/partials/funnel/trio/rotation/bald-guy/rotation-bald-guy-4.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/rotation-${prefix}.json,bald-guy/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '6%',
            y: '24%'
        }
    },

    //---------------------------------------------------------------------------------------

    charlesLeft1: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/charles/1/left-charles-0.png',
            '/img/partials/funnel/trio/left/charles/1/left-charles-1.png',
            '/img/partials/funnel/trio/left/charles/1/left-charles-2.png',
            '/img/partials/funnel/trio/left/charles/1/left-charles-3.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,charles/1`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        },
    },

    charlesLeft2: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/charles/2/left-charles-0.png',
            '/img/partials/funnel/trio/left/charles/2/left-charles-1.png',
            '/img/partials/funnel/trio/left/charles/2/left-charles-2.png',
            '/img/partials/funnel/trio/left/charles/2/left-charles-3.png',
            '/img/partials/funnel/trio/left/charles/2/left-charles-4.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,charles/2`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        },
    },

    charlesLeft3: {
        type: 'movieclip',
        /* texture: [
            '/img/partials/funnel/trio/left/charles/3/left-charles-0.png',
            '/img/partials/funnel/trio/left/charles/3/left-charles-1.png',
            '/img/partials/funnel/trio/left/charles/3/left-charles-2.png',
            '/img/partials/funnel/trio/left/charles/3/left-charles-3.png',
            '/img/partials/funnel/trio/left/charles/3/left-charles-4.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,charles/3`,
        scale: {
            x: '80%',
        },
        position: {
            x: '-2%',
            y: '22%',
        },
    },

    charlesMiddle: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/middle/charles/charles-middle.png',
        //     '/img/partials/funnel/trio/middle/charles/charles-left.png',
        //     '/img/partials/funnel/trio/middle/charles/charles-right.png',
        // ],
        texture: `sprite:/img/partials/funnel/trio/middle-${prefix}.json,charles/`,
        scale: {
            x: '76%',
        },
        position: {
            x: '12%',
            y: '22%',
        },
    },

    charlesRight: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/right/charles/right-charles-0.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-1.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-2.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-3.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-4.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-5.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-6.png',
        //     '/img/partials/funnel/trio/right/charles/right-charles-7.png',
        // ],
        texture: `sprite:/img/partials/funnel/trio/right-${prefix}.json,charles/`,
        scale: {
            x: '78%',
        },
        position: {
            x: '23%',
            y: '24%',
        },
    },

    charlesRotation: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/rotation/charles/rotation-charles-0.png',
        //     '/img/partials/funnel/trio/rotation/charles/rotation-charles-1.png',
        //     '/img/partials/funnel/trio/rotation/charles/rotation-charles-2.png',
        //     '/img/partials/funnel/trio/rotation/charles/rotation-charles-3.png',
        //     '/img/partials/funnel/trio/rotation/charles/rotation-charles-4.png',
        // ],
        texture: `sprite:/img/partials/funnel/trio/rotation-${prefix}.json,charles/`,
        scale: {
            x: '80%',
        },
        position: {
            x: '6%',
            y: '24%',
        },
    },

    //---------------------------------------------------------------------------------------

    girlLeft1: {
        type: 'movieclip',
        scale: {
            x: '80%'
        },
        position: {
            x: '-2%',
            y: '22%'
        },
        /* texture: [
            '/img/partials/funnel/trio/left/girl/1/left-girl-0.png',
            '/img/partials/funnel/trio/left/girl/1/left-girl-1.png',
            '/img/partials/funnel/trio/left/girl/1/left-girl-2.png',
            '/img/partials/funnel/trio/left/girl/1/left-girl-3.png'
        ],*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,girl/1`,
    },

    girlLeft2: {
        type: 'movieclip',
        scale: {
            x: '80%'
        },
        position: {
            x: '-2%',
            y: '22%'
        },
        /* texture: [
            '/img/partials/funnel/trio/left/girl/2/left-girl-0.png',
            '/img/partials/funnel/trio/left/girl/2/left-girl-1.png',
            '/img/partials/funnel/trio/left/girl/2/left-girl-2.png',
            '/img/partials/funnel/trio/left/girl/2/left-girl-3.png'
        ]*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,girl/2`,
    },

    girlLeft3: {
        type: 'movieclip',
        scale: {
            x: '80%'
        },
        position: {
            x: '-2%',
            y: '22%'
        },
        /* texture: [
            '/img/partials/funnel/trio/left/girl/3/left-girl-0.png',
            '/img/partials/funnel/trio/left/girl/3/left-girl-1.png',
            '/img/partials/funnel/trio/left/girl/3/left-girl-2.png',
            '/img/partials/funnel/trio/left/girl/3/left-girl-3.png'
        ]*/
        texture: `sprite:/img/partials/funnel/trio/left-${prefix}.json,girl/3`,
    },

    girlMiddle: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/middle/girl/girl-middle.png',
        //     '/img/partials/funnel/trio/middle/girl/girl-left.png',
        //     '/img/partials/funnel/trio/middle/girl/girl-right.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/middle-${prefix}.json,girl/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '14%',
            y: '20%'
        }
    },

    girlRight: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/right/girl/right-girl-0.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-1.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-2.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-3.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-4.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-5.png',
        //     '/img/partials/funnel/trio/right/girl/right-girl-6.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/right-${prefix}.json,girl/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '24%',
            y: '22%'
        }
    },

    girlRotation: {
        type: 'movieclip',
        // texture: [
        //     '/img/partials/funnel/trio/rotation/girl/rotation-girl-0.png',
        //     '/img/partials/funnel/trio/rotation/girl/rotation-girl-1.png',
        //     '/img/partials/funnel/trio/rotation/girl/rotation-girl-2.png',
        //     '/img/partials/funnel/trio/rotation/girl/rotation-girl-3.png',
        //     '/img/partials/funnel/trio/rotation/girl/rotation-girl-4.png'
        // ],
        texture: `sprite:/img/partials/funnel/trio/rotation-${prefix}.json,girl/`,
        scale: {
            x: '80%'
        },
        position: {
            x: '6%',
            y: '24%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/trioFunnel.js